import {
    ADMIN_ROUTE_PART,
    DIS_APEER_ROUTE,
    RUNNER_ROUTE_PART,
    SUBMITTED_WORKFLOWS_ROUTE_PART,
    USER_WORKSPACE_ROUTE,
    WORKFLOW_EDITOR_ROUTE_PART,
} from './../../app/shared/constants/constants';

export function isInWorkspace(url: string): boolean {
    return url?.includes(`${USER_WORKSPACE_ROUTE}/`);
}
export function isInAdmin(url: string): boolean {
    return url?.includes(`${ADMIN_ROUTE_PART}/`);
}
export function isInWorkflowEditor(url: string): boolean {
    return url?.includes(`${WORKFLOW_EDITOR_ROUTE_PART}/`);
}
export function isInDisApeer(url: string): boolean {
    return url?.includes(`${DIS_APEER_ROUTE}`);
}
export function isInRunner(url: string): boolean {
    return url?.includes(`${RUNNER_ROUTE_PART}`);
}
export function isInSubmittedWorkflows(url: string): boolean {
    return url?.includes(`${SUBMITTED_WORKFLOWS_ROUTE_PART}`);
}
